import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SanitizerService {
  constructor() {}

  sanitizeFilter(raw: string): string {
    return raw.replace(/(\"|\'|\(|\)|\;|\,|\=|\!|\~|\<|\>)/g, '\\$1');
  }
}
